import { type ReactElement } from 'react';

import LoginBackgroundImage from '@/Assets/Images/login-background.webp';
import Splash from '@/components/Splash';
import CenterValidationDialog, {
  CenterValidationFormData,
} from '@/pages/CenterValidation/components/CenterValidationDialog';

function LoginSlide({ children }: { children: ReactElement }) {
  return (
    <div className="absolute inset-0 animate-fadeIn opacity-0">
      <div
        className="flex h-full w-full items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${LoginBackgroundImage})` }}
      >
        <div className="absolute right-0 z-elevated flex h-full w-full animate-splashLogo items-center justify-center rounded-l-[1.5em] bg-neutral-white sm:w-[27em] md:w-[30em] lg:w-[35em] xl:w-[38.4375em]">
          {children}
        </div>
      </div>
    </div>
  );
}

interface SchoolSetupScreenProperties {
  errors: Record<string, string>;
  isSubmitting: boolean;
  resetValidation: () => void;
  onSubmitCenterDetails: (data: CenterValidationFormData) => void;
}

export default function SchoolSetupScreen({
  errors,
  isSubmitting,
  resetValidation,
  onSubmitCenterDetails,
}: SchoolSetupScreenProperties): ReactElement {
  return (
    <>
      <Splash />
      <LoginSlide>
        <CenterValidationDialog
          errors={errors}
          isSubmitting={isSubmitting}
          resetValidation={resetValidation}
          onSubmitCenterDetails={onSubmitCenterDetails}
        />
      </LoginSlide>
    </>
  );
}
